import { FC } from 'react';

import classNames from 'classnames';

import { useBreakpoint } from '../../hooks/useBreakpoint';
import { Breakpoint } from '../../utils/breakpoint';

import { TariffCardInfoLabel } from './tariff-card-info-label';

const disclaimer = 'ВАЖНО!';
const disclaimerUnderline = false;
const infoText1 = 'Вы можете выбрать и оплатить другой тариф в любое время — даже до окончания текущего.';
const infoText2 =
  'Это обеспечит непрерывный доступ к инструментам: новый тариф активируется после завершения действующего.';
const noAutoRenewText =
  'Команда ZiNGiZi сознательно отказалась от автопродления, чтобы гарантировать честность и полное отсутствие неожиданных списаний. ';

export interface ITariffInfoPanelProps {
  isPromo: boolean;
}
export const TariffInfoPanel: FC<ITariffInfoPanelProps> = ({ isPromo }) => {
  const breakpoint = useBreakpoint();

  if (!isPromo) {
    return (
      <div className="flex flex-col gap-3 md:gap-0 font-manrope font-regular overflow-hidden text-[12px] lg:text-[16px]">
        <p className="text-center lg:text-start">{infoText1}</p>
        <p className="text-center lg:text-start">{infoText2}</p>
        <div className="mt-3">
          <TariffCardInfoLabel title={noAutoRenewText} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-5 item-center justify-center p-3 font-comfortaa font-normal text-[12px] md:text-[16px] lg:font-semibold overflow-hidden lg:text-[24px] leading-tight">
      {breakpoint >= Breakpoint.Lg && (
        <center>
          <p
            className={classNames('text-[#C00000]', {
              'underline decoration-3 decoration-[#dec05e] text-[32px]': disclaimerUnderline,
            })}
          >
            {disclaimer}
          </p>
        </center>
      )}
      <>
        <center>
          <p>{infoText1}</p>
        </center>
        <center>
          <p>{infoText2}</p>
        </center>
        <div className="mt-3">
          <TariffCardInfoLabel title={noAutoRenewText} />
        </div>
      </>
    </div>
  );
};
